import curry from 'lodash/curry';
import { css, FlattenSimpleInterpolation } from 'styled-components';

import IThemeInterface, { VALID_BREAKPOINTS_WITH_BASE } from '../../Theme/common';
import { VALID_GLOBAL_FONT_SIZES } from '../../Typography/common';
import { MakeMediaMap } from '../Typing/tsHelpers';

import { calcMediaStyles } from './CalcMediaStyles/calcMediaStyles';
import { VALID_PICKED_MEDIA } from './common';
import { makeMediaObj } from './makeMediaObj';
import { normalizeMediaStyles } from './normalizeMediaStyles';

export type VALID_FONT_SIZE_DATA = MakeMediaMap<VALID_BREAKPOINTS_WITH_BASE> | VALID_GLOBAL_FONT_SIZES;

export const calcFontSize = curry((
  theme: IThemeInterface,
  size: VALID_FONT_SIZE_DATA,
): FlattenSimpleInterpolation[] => {

  const styles: FlattenSimpleInterpolation[] = [];

  if (typeof size === 'object') {
    const pickedSizes: VALID_PICKED_MEDIA = makeMediaObj(size);
    const normalizedMedia: VALID_PICKED_MEDIA = normalizeMediaStyles(theme, pickedSizes, 'fontSize');
    const responsiveSizes = calcMediaStyles(normalizedMedia, 'font-size');

    styles.push(responsiveSizes);
  } else {
    styles.push(css`
      font-size: ${theme.global.font.size[size] || size};
    `);
  }

  return styles;
});
